
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FundListingPPSS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PPSS"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}},{"kind":"Argument","name":{"kind":"Name","value":"productType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productType"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetclass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invfocus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alternateivefor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invtenure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareclass"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prmryshclind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifiers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shclcode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month_end"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret1yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret3yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret5yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannret10yr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgannretactinc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcnamestd"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":618}};
    doc.loc.source = {"body":"query FundListingPPSS(\n  $countrycode: String!\n  $languagecode: String!\n  $productType: String!\n) {\n  PPSS(\n    countrycode: $countrycode\n    languagecode: $languagecode\n    productType: $productType\n  ) {\n    fundid\n    fundname\n    assetclass\n    invfocus\n    alternateivefor\n    invtenure\n    shareclass {\n      prmryshclind\n      identifiers {\n        fundid\n        shclcode\n      }\n      performance {\n        month_end {\n          asofdate\n          avgannret1yr\n          avgannret3yr\n          avgannret5yr\n          avgannret10yr\n          avgannretactinc\n          calcnamestd\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FundListingPPSS"] = oneQuery(doc, "FundListingPPSS");
        
